import CustomerProfile from "../../customer/profile/Profile";

const Profile = () => {
  return <CustomerProfile externalUser={true} />;
}

export default Profile;